let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ii98U")).then(() => parcelRequire('6vvjk'));